import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  ACCEPT_ALL,
  REJECT_ALL,
  getStoredConsent,
  saveConsent,
} from "@/lib/cookieConsent";

export const CookieConsent = () => {
  const [open, setOpen] = useState(false);


  useEffect(() => {
    const existing = getStoredConsent();
    if (!existing) setOpen(true);
    const onOpen = () => setOpen(true);
    window.addEventListener("open-cookie-preferences", onOpen);
    return () => window.removeEventListener("open-cookie-preferences", onOpen);
  }, []);


  if (!open) return null;

  const handleAccept = () => {
    saveConsent(ACCEPT_ALL, "accept_all");
    setOpen(false);
  };
  const handleReject = () => {
    saveConsent(REJECT_ALL, "reject_all");
    setOpen(false);
  };


  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[100] p-3 sm:p-4"
    >
      <div className="mx-auto max-w-4xl rounded-xl border border-border bg-background shadow-2xl">
        <div className="p-4 sm:p-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <div className="text-sm text-foreground">
              <p className="font-semibold mb-1">We value your privacy</p>
              <p className="text-muted-foreground">
                We use cookies to improve your experience, analyse traffic, and for marketing.
                See our{" "}
                <Link to="/cookie-policy" className="underline">
                  Cookie Policy
                </Link>
                .
              </p>
            </div>
            <div className="flex flex-wrap gap-2 sm:flex-nowrap">
              <Button variant="outline" size="sm" onClick={handleReject}>
                Reject
              </Button>
              <Button size="sm" onClick={handleAccept}>
                Accept all
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};




